import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PutShiftSettingEntity } from '../../domain/entities/PutShiftSettingEntity'
import { PutShiftSettingRegionModel } from './PutShiftSettingRegionModel'

export class PutShiftSettingModel extends PutShiftSettingEntity {
  constructor(dataDto: PutShiftSettingEntity) {
    super()
    mapEntityProperties<PutShiftSettingModel>(this, dataDto, {
      map: {
        shiftSettingRegions: dataDto.shiftSettingRegions?.map(
          (region) => new PutShiftSettingRegionModel(region)
        )
      }
    })
  }
}
